import { useApiPostRequest } from '../hooks/useApiPostRequest';
import {
  POST_EXPORT_REPORT_CSV_PATH,
  PostExportReportCsvErrorDto,
  PostExportReportCsvRequestBodyData,
  PostExportReportCsvRequestPathVariables,
  PostExportReportCsvRequestQueryParams,
  PostExportReportCsvSuccessDto,
} from './types/reports';

export const usePostExportReportCsv = () => {
  return useApiPostRequest<
    PostExportReportCsvRequestPathVariables,
    PostExportReportCsvRequestQueryParams,
    PostExportReportCsvRequestBodyData,
    PostExportReportCsvSuccessDto,
    PostExportReportCsvErrorDto
  >(POST_EXPORT_REPORT_CSV_PATH);
};
